import styled from "styled-components"
import { BaseLayoutCSS } from "../style.shared"

export const StyledLayoutPlain = styled.div`
  ${BaseLayoutCSS};
`
